import { useEffect, useState } from 'react'
import { ICriteria } from '../../../protection.types'
import { useParams } from 'react-router-dom'
import Button from 'shared/Buttons/Button/Button'
import CriteriaTemplate from '../CriteriaTemplate'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import eventBus from 'services/eventBus'
import protectionTemplateApi from '../../../protection.api'
import { useNavigate } from 'react-router-dom'

const UpdateProtectionCriteria = () => {
  const { wait } = useHttpLoader()
  const params = useParams()
  const navigate = useNavigate()

  const [criteriaDraft, setCriteriaDraft] = useState<ICriteria[]>([])

  const handleChange = (criteriaId: string) => (value: any, name: string) => {
    setCriteriaDraft((prev) =>
      prev.map((criteria) => (criteria.id === criteriaId ? { ...criteria, [name]: value } : criteria))
    )
  }

  useEffect(() => {
    if (!params.id) return

    wait(protectionTemplateApi.getTemplateCriteaFromTemplate(params.id), (resp) => {
      if (resp.status === 'success') {
        if (resp.body && Array.isArray(resp.body)) {
          setCriteriaDraft(resp.body)
        }
      }
    })
  }, [params.id])

  const handleAddCriteria = () => {
    const newCriteria: ICriteria = {
      id: crypto.randomUUID(),
      name: '',
      description: '',
      minValue: 0,
      maxValue: 10,
    }
    setCriteriaDraft((prev) => [...prev, newCriteria])
  }

  const handleSaveAll = async () => {
    const requests = criteriaDraft.map((criteria) => {
      const isExisting = criteria.ratingTemplateId

      const criteriaData = {
        name: criteria.name,
        description: criteria.description,
        minValue: criteria.minValue,
        maxValue: criteria.maxValue,
        ratingTemplateId: params.id,
      }

      return isExisting
        ? protectionTemplateApi.updateCriteriaFromTemplate(criteria.id, criteriaData)
        : protectionTemplateApi.createCriteriaFromTemplate(params.id, criteriaData)
    })

    try {
      const responses = await Promise.all(requests)

      eventBus.pub('ntf.message', {
        type: 'info',
        message: 'Все критерии успешно сохранены',
      })

      setCriteriaDraft((prev) =>
        prev.map((criteria, index) => {
          const resp = responses[index]

          if (!criteria.ratingTemplateId && resp?.body) {
            return {
              ...resp.body,
              id: resp.body.id,
            } as ICriteria
          }

          return criteria
        })
      )
    } catch (e) {
      eventBus.pub('ntf.message', {
        type: 'error',
        message: 'Ошибка при сохранении критериев',
      })
    }
  }

  const handleDeleteCriteria = (criteria: ICriteria) => {
    const isExisting = (criteria as any).ratingTemplateId

    if (isExisting) {
      wait(protectionTemplateApi.deleteCriteriaFromTemplate(criteria.id), (resp) => {
        if (resp.status === 'success') {
          eventBus.pub('ntf.message', {
            type: 'info',
            message: 'Критерий успешно удален',
          })
          setCriteriaDraft((prev) => prev.filter((c) => c.id !== criteria.id))
        }
      })
    } else {
      setCriteriaDraft((prev) => prev.filter((c) => c.id !== criteria.id))
    }
  }

  const handleDeleteTemplate = () => {
    wait(protectionTemplateApi.deleteTemplate(params.id), (resp) => {
      if (resp.status === 'success') {
        eventBus.pub('ntf.message', {
          type: 'info',
          message: 'Шаблон успешно удален',
        })
        navigate('/admin/protection-templates')
      }
    })
  }

  return (
    <>
      <div>
        <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'end', gap: '12px' }}>
          <Button theme='primary' onClick={handleAddCriteria} size='s' fullWidth={false}>
            Добавить
          </Button>
          <Button theme='primary' onClick={handleSaveAll} size='s' fullWidth={false}>
            Сохранить все
          </Button>
          <Button theme='danger' onClick={handleDeleteTemplate} size='s' fullWidth={false}>
            Удалить шаблон
          </Button>
        </div>
        <div className='grid-form-2' style={{ marginTop: '16px' }}>
          {criteriaDraft.map((criteria) => (
            <CriteriaTemplate key={criteria.id} criteria={criteria} onChange={handleChange(criteria.id)}>
              <div className='form-footer'>
                <div className='inline-flex-gap'>
                  <Button theme='danger' onClick={() => handleDeleteCriteria(criteria)} fullWidth={false}>
                    Удалить
                  </Button>
                </div>
              </div>
            </CriteriaTemplate>
          ))}
        </div>
      </div>
    </>
  )
}

export default UpdateProtectionCriteria
